import React, { useState, useEffect } from "react";
import * as Parse from "parse";
import { ToastContainer } from 'react-toastify';
import { Box, FormControl, InputLabel, MenuItem, Select, useTheme, Button, Typography, Grid, Container } from "@mui/material";
import Spinner from 'react-bootstrap/Spinner';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { tokens } from "../theme";
import frame from "../assets/images/palletFrame.png";
import beam from "../assets/images/palletBeam.png";
import meshDeck from '../assets/images/meshDeck.png';
import PalletRackingPart, { ACCESSORY, MESH_DECK, MISC, ROW_SPACER } from "./PalletRackingPart";
import cogs from '../assets/images/adjust.png';
import barSupport from '../assets/images/palletBarSupport.png';
import FramePalletRacking from "./FramePalletRackPart";
import BeamPalletRacking from "./BeamPalletRackingPart";
import rowSpacer from '../assets/images/rowSpacers.png';

import accessories from '../assets/images/settings.png';
import MiscPart from "../components/MiscPart";
import CreateMiscPart from "../components/CreateMiscPart";


const BuildCustomProducts = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [palletRackingParts, setPalletRackingParts] = useState([]);
    const [cartItems, setCartItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentActive, setCurrentActive] = useState(1);
    const [condition, setCondition] = React.useState('New');
    const navigate = useNavigate();
    const cartSection = useSelector((state) => state.cart.sections);
    const miscParts = useSelector((state) => state.cart.miscCantileverItems);
    const [frameDimensions, setFrameDimensions] = useState()
    const [beamDimensions, setBeamDimensions] = useState()

    useEffect(() => {
        getPalletRackingParts(currentActive)
    }, [currentActive, condition]);

    const getPalletRackingParts = async (currentActivePart) => {
        let query;
        if (condition === 'Used') {
            query = new Parse.Query(Parse.Object.extend("PalletRackingPartsUsed"));
        } else {
            query = new Parse.Query(Parse.Object.extend("PalletRackingParts"));
        }
        setIsLoading(true);
        if (currentActivePart === 1) {
            const frameDimensionsList1 = [];
            const frameDimensionsList2 = [];
            query.equalTo("name", "Frame");
            const data = await query.find();
            data.map((frame) => {
                if (frame.get("description").split(" ").includes("838mm")) {
                    return frameDimensionsList1.push(frame);
                } else {
                    return frameDimensionsList2.push(frame);
                }
            });
            const updatedList1 = Object.values(frameDimensionsList1).sort(function (a, b) {
                var regex = /(\d+)|(\D+)/g;
                var aParts = a.get('description').match(regex);
                var bParts = b.get('description').match(regex);

                for (var i = 0; i < Math.min(aParts.length, bParts.length); i++) {
                    var aIsNumber = !isNaN(aParts[i]);
                    var bIsNumber = !isNaN(bParts[i]);

                    if (aIsNumber && bIsNumber) {
                        var aNum = parseInt(aParts[i]);
                        var bNum = parseInt(bParts[i]);

                        if (aNum !== bNum) {
                            return aNum - bNum;
                        }
                    } else if (aIsNumber) {
                        return -1;
                    } else if (bIsNumber) {
                        return 1;
                    } else {
                        var aStr = aParts[i].toLowerCase();
                        var bStr = bParts[i].toLowerCase();

                        if (aStr !== bStr) {
                            return aStr.localeCompare(bStr);
                        }
                    }
                }

                return aParts.length - bParts.length;
            });
            const updatedList2 = Object.values(frameDimensionsList2).sort(function (a, b) {
                var regex = /(\d+)|(\D+)/g;
                var aParts = a.get('description').match(regex);
                var bParts = b.get('description').match(regex);

                for (var i = 0; i < Math.min(aParts.length, bParts.length); i++) {
                    var aIsNumber = !isNaN(aParts[i]);
                    var bIsNumber = !isNaN(bParts[i]);

                    if (aIsNumber && bIsNumber) {
                        var aNum = parseInt(aParts[i]);
                        var bNum = parseInt(bParts[i]);

                        if (aNum !== bNum) {
                            return aNum - bNum;
                        }
                    } else if (aIsNumber) {
                        return -1;
                    } else if (bIsNumber) {
                        return 1;
                    } else {
                        var aStr = aParts[i].toLowerCase();
                        var bStr = bParts[i].toLowerCase();

                        if (aStr !== bStr) {
                            return aStr.localeCompare(bStr);
                        }
                    }
                }

                return aParts.length - bParts.length;
            });
            setFrameDimensions([{ 1: updatedList1 }, { 2: updatedList2 }]);
            setPalletRackingParts(data);
            setIsLoading(false);
        } else if (currentActive === 2) {
            query.equalTo("name", "Beam");
            const beamDimensionsList1 = [];
            const beamDimensionsList2 = [];
            const beamDimensionsList3 = [];
            const beamDimensionsList4 = [];
            const beamDimensionsList5 = [];
            const beamDimensionsList6 = [];
            const data = await query.find();
            data.map((beam) => {
                if (beam.get("description").split(" ").includes("80")) {
                    return beamDimensionsList1.push(beam);
                } else if (beam.get("description").split(" ").includes("100")) {
                    return beamDimensionsList2.push(beam);
                } else if (beam.get("description").split(" ").includes("120")) {
                    return beamDimensionsList3.push(beam);
                } else if (beam.get("description").split(" ").includes("140")) {
                    return beamDimensionsList4.push(beam);
                } else if (beam.get("description").split(" ").includes("160")) {
                    return beamDimensionsList5.push(beam);
                } else {
                    return beamDimensionsList6.push(beam);
                }
            });
            const beamUpdatedList1 = Object.values(beamDimensionsList1).sort(function (a, b) {
                var regex = /(\d+)|(\D+)/g;
                var aParts = a.get('description').match(regex);
                var bParts = b.get('description').match(regex);

                for (var i = 0; i < Math.min(aParts.length, bParts.length); i++) {
                    var aIsNumber = !isNaN(aParts[i]);
                    var bIsNumber = !isNaN(bParts[i]);

                    if (aIsNumber && bIsNumber) {
                        var aNum = parseInt(aParts[i]);
                        var bNum = parseInt(bParts[i]);

                        if (aNum !== bNum) {
                            return aNum - bNum;
                        }
                    } else if (aIsNumber) {
                        return -1;
                    } else if (bIsNumber) {
                        return 1;
                    } else {
                        var aStr = aParts[i].toLowerCase();
                        var bStr = bParts[i].toLowerCase();

                        if (aStr !== bStr) {
                            return aStr.localeCompare(bStr);
                        }
                    }
                }

                return aParts.length - bParts.length;
            });

            setBeamDimensions([{ 1: beamUpdatedList1 }, { 2: beamDimensionsList2 }, { 3: beamDimensionsList3 }, { 4: beamDimensionsList4 }, { 5: beamDimensionsList5 }, { 6: beamDimensionsList6 }]);
            setPalletRackingParts(data);
            setIsLoading(false);
        } else if (currentActive === 3) {
            query.equalTo("name", "Support");
            const data = await query.find();
            setPalletRackingParts(data);
            setIsLoading(false);
        } else if (currentActive === 4) {
            query.equalTo("name", ROW_SPACER);
            const data = await query.find();
            setPalletRackingParts(data);
            setIsLoading(false);
        } else if (currentActive === 5) {
            query.equalTo("name", MESH_DECK);
            const data = await query.find();
            setPalletRackingParts(data);
            setIsLoading(false);
        } else if (currentActive === 6) {
            query.equalTo("name", ACCESSORY);
            const data = await query.find();
            setPalletRackingParts(data);
            setIsLoading(false);
        } else if (currentActive === 7) {
            query.equalTo("name", MISC);
            const data = await query.find();
            setPalletRackingParts(data);
            setIsLoading(false);
        }
    };

    const handleConditionChange = (event) => {
        setCondition(event.target.value);
    };


    return (
        <Container maxWidth="lg">
            <Box
                display='flex'
                flexDirection='column'
                justifyContent='center'
                alignItems='center'
                py={4}
            >
                <div>
                    <ToastContainer />
                </div>

                <Grid container spacing={3}>
                    {miscParts.map((part, index) => {
                        if (part.section === cartSection.currentActive) {
                            return (
                                <Grid item xs={12} sm={6} md={4} key={part.id}>
                                    <MiscPart 
                                        id={part.id} 
                                        part={part.part} 
                                        quantity={part.quantity} 
                                    />
                                </Grid>
                            );
                        }
                        return null;
                    })}
                    <Grid item xs={12} sm={6} md={4}>
                        <CreateMiscPart custom={true} />
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};
export default BuildCustomProducts;
